import cn from 'classnames';

import { LoaderInline } from '@webapp/common/assets/icons';

import css from './loader.css';

export const Loader: FC<{
    className?: string;
    inline?: boolean;
    small?: boolean;
    visible?: boolean;
    inlineElement?: boolean;
}> = ({ className, inline, inlineElement, small, visible }) => {
    const classNames = cn(
        css.loader,
        {
            [css.inline]: inline,
            [css.small]: small,
        },
        visible ? css.visible : css.hidden,
        className,
    );

    return inlineElement ? (
        <span className={classNames}>
            <LoaderInline />
        </span>
    ) : (
        <div className={classNames}>
            <LoaderInline />
        </div>
    );
};
